import { defineMessages } from 'react-intl';
export default defineMessages({
    celsius: {
        id: 'units.celsius',
        defaultMessage: 'Celsius'
    },
    fahrenheit: {
        id: 'units.fahrenheit',
        defaultMessage: 'Fahrenheit'
    },
    inch: {
        id: 'units.inch',
        defaultMessage: 'Inches'
    },
    inchOfMercury: {
        id: 'units.inchOfMercury',
        defaultMessage: 'Inches of mercury'
    },
    kelvin: {
        id: 'units.kelvin',
        defaultMessage: 'Kelvin'
    },
    kilometerPerHour: {
        id: 'units.kilometerPerHour',
        defaultMessage: 'Kilometers per hour'
    },
    knot: {
        id: 'units.knot',
        defaultMessage: 'Knots'
    },
    meterPerSecond: {
        id: 'units.meterPerSecond',
        defaultMessage: 'Meters per second'
    },
    milePerHour: {
        id: 'units.milePerHour',
        defaultMessage: 'Miles per hour'
    },
    millibar: {
        id: 'units.millibar',
        defaultMessage: 'Millibars'
    },
    millimeter: {
        id: 'units.millimeter',
        defaultMessage: 'Millimeters'
    },
    millimeterOfMercury: {
        id: 'units.millimeterOfMercury',
        defaultMessage: 'Millimeters of mercury'
    }
});
